import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';

interface Props {
  image: string;
  mobileImage?: string;
  title?: string;
  subtitle?: string;
 position?: 'top' | 'center' | 'bottom';
   textColor?: string;  
}

const HeroImgDeskAndMobil = ({
  image,
  mobileImage,
  title,
  subtitle,
  position = 'center',
  textColor = 'text-white',
}: Props) => {
  const textPositionClass =
  position === 'top'
    ? 'top-10 left-1/2 -translate-x-1/2'
    : position === 'bottom'
    ? 'bottom-5 left-1/2 -translate-x-1/2'
    : 'left-1/2 -translate-x-1/2 top-[65%] -translate-y-1/2 sm:top-1/2'; 

  return (
    <section className="relative flex w-full h-[80vh] max-h-[918px] lg:max-h-[1018px]">
      <picture className="absolute inset-0 z-0">
        <source media="(min-width:1024px)" srcSet={image} />
        <img
          src={mobileImage ?? image}
          alt={title ?? ''}
          className="w-full h-full object-cover object-[center_20%] select-none"
          loading="eager"
          decoding="async"
        />
      </picture>

      {(title || subtitle) && (
        <m.div
          variants={containerVariants}
          viewport={viewPort}
          initial="hidden"
          whileInView="visible"
          className={`absolute z-10 ${textPositionClass} w-full text-center grid gap-1 ${textColor} px-4`}
        >
          {title && (
            <m.h1
              variants={itemVariants}
              className="font-medium leading-tight whitespace-pre-line"
              style={{ fontSize: 'clamp(20px, 8vw, 72px)' }}
            >
              {title}
            </m.h1>
          )}
          {subtitle && (
            <m.p
              variants={itemVariants}
              className="text-xl sm:text-2xl leading-tight whitespace-pre-line"
            >
              {subtitle}
            </m.p>
          )}
        </m.div>
      )}
    </section>
  );
};

export default HeroImgDeskAndMobil;
